<template>
  <div>
    <el-dialog
      :title="'号码导入'"
      :visible.sync="visible"
      width="35%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-alert type="info" :closable="false" style="margin-bottom: 20px">
        <div
          slot="title"
          style="font-weight: bold; font-size: 24px; color: #333"
        >
          号码导入(用excel表格快速导入本地号码)
        </div>
      </el-alert>
      <el-form
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="150px"
      >
          <el-form-item label="自动复机:" v-show="dataForm.IsStop">
            <el-select v-model="dataForm.RepeatedStatus" placeholder="自动复机">
              <el-option label="手动复机" value="None"></el-option>
              <el-option label="自动复机（1天）" value="OneDay"></el-option>
              <el-option label="自动复机（2天）" value="TwoDay"></el-option>
              <el-option label="自动复机（3天）" value="ThreeDay"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="停机类型:" v-show="dataForm.IsStop">
            <el-select v-model="dataForm.OperationType" placeholder="停机类型">
              <el-option label="手工停机" value="手工停机"></el-option>
              <el-option label="黑名单停机" value="黑名单停机"></el-option>
              <el-option label="欠费停机" value="欠费停机"></el-option>
              <el-option label="未续费停机" value="未续费停机"></el-option>
              <el-option label="质检停机" value="质检停机"></el-option>
              <el-option label="投诉停机" value="投诉停机"></el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="号码excel文件" prop="file">
          <input
            type="file"
            id="file"
            accept=".xls,.xlsx"
            @change="beforeUpload"
            hidden
          />
          <el-button type="primary" @click="upfile"
            >点击上传号码excel文件</el-button
          >
          <div>
            你需要使用指定的模板文件才能正确导入!
            <el-button type="text" @click="download"
              ><u>下载号码导入模板</u></el-button
            >
          </div>
          <el-alert
            :title="dataForm.file ? dataForm.file.name : ''"
            v-show="dataForm.file"
            type="info"
            closable
            @close="dataForm.file = null"
          />
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="confirmLoading" @click="ok"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      dataForm: {
        file: null,
        RepeatedStatus: 'None',
        OperationType: '手工停机',
        IsStop: true,
      },
      type: 1,//1停机2复机
      files: null,
      rules: {
        file: {
          required: true,
          message: "请上传号码excel文件",
          trigger: "change",
        },
      },
    };
  },
  methods: {
    init(IsStop) {
      this.dataForm.IsStop = IsStop;
      this.visible = true;
      this.type = this.dataForm.IsStop?1:2;
      this.dataForm.RepeatedStatus = this.dataForm.RepeatedStatus
      this.dataForm.OperationType = this.dataForm.OperationType
    },
    upfile() {
      const input = document.querySelector("#file");
      input.click();
    },
    beforeUpload(e) {
      this.readExcel(e);
      e.srcElement.value = "";
    },
    readExcel(e) {
      const file = e.target.files[0];
      this.files = e.target.files;
      console.log(e.target.files);
      this.dataForm.file = file;
      this.$refs.dataForm.validateField("file");
    },
    handleClose() {
      this.$refs.dataForm.resetFields();
      this.visible = false;
      this.dataForm.id = "";
    },
    ok() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const formData = new FormData();
          // for (let i = 0; i < this.files.length; i++) {
          //   formData.append("file", this.files[i]);
          // }
          formData.append("file", this.dataForm.file);
          formData.append("type", this.dataForm.IsStop?1:2);
          formData.append("RepeatedStatus", this.dataForm.RepeatedStatus);
          formData.append("OperationType", this.dataForm.IsStop ? this.dataForm.OperationType : "复机");
          this.$http({
            url: "/api/FilterCaller/ExcelStopOrOpen",
            method: "post",
            data: formData,
          })
            .then((res) => {
              debugger;
              if (res.data && res.data.success) {
                this.confirmLoading = false;
                console.log(res);
                this.$message.success(res.data.msg);
                this.handleClose();
                this.$emit("ok");
              }
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * 下载模板
     */
    download() {
      const url = "/号码导入模板.xlsx";
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style>
</style>